import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getInterestRule } from "../common/service";

export function interestRulesLoader() {
  return defer({
    coreData: resolveLoaderResult(getInterestRule()),
  });
}
